import * as actions from "./actions";
import constants from "./constants";
import reducer from "./reducer";

export default {
  actions,
  reducer,
  constants,
};
